module.exports = __webpack_public_path__ + "static/media/latlong2.c434a223.csv";